import { Box } from '@chakra-ui/react';
import * as React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { ImageUploadButton } from '@/components/ImageUploadButton';
import { EPrepImagesSource } from '@/graphql-types/globalTypes';

export const ImageButton: React.FC<{ imageLimit?: number }> = ({
  imageLimit,
}) => {
  const { trigger } = useFormContext();

  return (
    <Box>
      <Controller
        name="images"
        rules={{
          validate: (value) => {
            return (
              imageLimit === undefined ||
              !value ||
              value.length <= imageLimit ||
              `Cannot attach more than ${imageLimit} image${
                imageLimit !== 1 ? 's' : ''
              } `
            );
          },
        }}
        render={({ field: { onChange, value, ref, onBlur } }) => (
          <ImageUploadButton
            colorScheme="gray"
            size="sm"
            borderRadius="full"
            source={EPrepImagesSource.COMMENT}
            value={value}
            onChange={(value) => {
              onChange(value);
              trigger('images');
            }}
            onBlur={onBlur}
            ref={ref}
          />
        )}
      />
    </Box>
  );
};
